module.exports = __webpack_public_path__ + "img/ce0269e224796a5fb65acf317116a5f3.png";